module.exports = __webpack_public_path__ + "static/media/ony.677452fb.jpg";